import { Node } from "@tiptap/core";

export interface IframeOptions {
  allowFullscreen: boolean;
  HTMLAttributes: {
    [key: string]: any;
  };
}

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    iframe: {
      setIframe: (options: { src: string }) => ReturnType;
    };
  }
}

export default Node.create<IframeOptions>({
  name: "iframe",
  group: "block",
  selectable: true,

  addOptions() {
    return {
      allowFullscreen: true,
      HTMLAttributes: {
        class: "iframe-wrapper",
      },
    };
  },

  addAttributes() {
    return {
      src: {
        default: null,
      },
      frameborder: {
        default: 0,
      },
      allowfullscreen: {
        default: this.options.allowFullscreen,
        parseHTML: () => this.options.allowFullscreen,
      },
      sandbox: {
        default:
          "allow-scripts allow-forms allow-top-navigation allow-presentation allow-same-origin allow-popups",
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "iframe",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    let wrapperClass = this.options.HTMLAttributes.class;

    return [
      "div",
      {
        ...this.options.HTMLAttributes,
        class: wrapperClass,
        "data-type": "iframe",
      },
      [
        "iframe",
        {
          ...HTMLAttributes,
          onclick:
            "event.stopPropagation(); this.closest('[data-type=\"iframe\"]').classList.toggle('has-focus')",
        },
      ],
    ];
  },

  renderText() {
    return "";
  },

  addCommands() {
    return {
      setIframe:
        (options: { src: string }) =>
        ({ tr, dispatch }) => {
          const { selection } = tr;
          const node = this.type.create(options);

          if (dispatch) {
            tr.replaceRangeWith(selection.from, selection.to, node);
          }

          return true;
        },
    };
  },
});
